import { createRealtimeDashboardTimeframeStats, createRealtimeRecordAgentStats, DashboardBreakdownType } from "..";
import { RandomGenerator } from "../../test-utils";
export var createEmailDashboardData = function (itemsLength, withUnassigned, emailDashboardBreakdownType) {
    if (itemsLength === void 0) { itemsLength = 5; }
    var items = new Array(itemsLength).fill(0).map(function (_, idx) { return ({
        realtimeData: {
            totalWaiting: RandomGenerator.randomNumber(1),
            totalActive: RandomGenerator.randomNumber(1),
            slaAboutToBreachedCount: RandomGenerator.randomNumber(1),
            slaBreachedCount: RandomGenerator.randomNumber(1),
        },
        itemName: withUnassigned && (idx === 0 || idx === 1) ? 'Unassigned' : emailDashboardBreakdownType === DashboardBreakdownType.LANGUAGE ?
            RandomGenerator.randomLocale() : RandomGenerator.randomString(),
        itemId: (withUnassigned && (idx === 0 || idx === 1)) || emailDashboardBreakdownType === DashboardBreakdownType.LANGUAGE ? undefined : RandomGenerator.randomId(),
        agentStats: createRealtimeRecordAgentStats(),
        timeframeStats: createRealtimeDashboardTimeframeStats(),
    }); });
    return ({
        items: items,
        itemsCount: itemsLength,
    });
};
export var createEmailDashboardStats = function () {
    return ({
        realtimeData: {
            totalWaiting: RandomGenerator.randomNumber(),
            totalActive: RandomGenerator.randomNumber(),
            longestWaitingTicket: {
                ticketId: RandomGenerator.randomTicket().id,
                statusStartDate: 1623847737018
            },
            slaAboutToBreachedCount: RandomGenerator.randomNumber(1),
            slaBreachedCount: RandomGenerator.randomNumber(1),
        },
        agentStats: createRealtimeRecordAgentStats(),
        timeframeStats: createRealtimeDashboardTimeframeStats()
    });
};
//# sourceMappingURL=builders.js.map